import { Action } from '@ngrx/store';
import { Beneficio, BeneficioCategoria, ContenidoStatus } from 'src/common/contenido';

export enum BeneficioActionTypes {
	BeneficioPageRequested = '[Beneficio Component] Beneficio Page Requested',
	BeneficioPageLoaded = '[Beneficio API] Beneficio Page Loaded',
	BeneficioPageCancelled = '[Beneficio API] Beneficio Page Cancelled',
	BeneficioPageRight = '[Beneficio API] Beneficio Page Right',
	BeneficioCategoriasRequested = '[Beneficio Component] Beneficio Categorias Requested',
	BeneficioCategoriasLoaded = '[Beneficio API] Beneficio Categorias Loaded',
	BeneficioCategoriasCancelled = '[Beneficio API] Beneficio Categorias Cancelled',
	BeneficioCategoriasRight = '[Beneficio API] Beneficio Categorias Right',
	BeneficioCategoriaChangeRequested = '[Beneficio Component] Beneficio Categoria Change Requested',
	BeneficioCategoriaChangeLoaded = '[Beneficio API] Beneficio Categoria Change Loaded',
	BeneficioCategoriaChangeCancelled = '[Beneficio API] Beneficio Categoria Change Cancelled'
}

export class BeneficioPageRequested implements Action {
	readonly type: string = BeneficioActionTypes.BeneficioPageRequested;
	constructor( public payload: { shouldLoadMoreContent: boolean } ) {
	}
}

export class BeneficioPageLoaded implements Action {
	readonly type: string = BeneficioActionTypes.BeneficioPageLoaded;
	constructor( public payload: { cleared: boolean, nextPageNum: number, status: ContenidoStatus, beneficio: Beneficio[] } ) {
	}
}

export class BeneficioPageCancelled implements Action {
	readonly type: string = BeneficioActionTypes.BeneficioPageCancelled;
	constructor( public payload: { status: ContenidoStatus } ) {
	}
}

export class BeneficioPageRight implements Action {
	readonly type: string = BeneficioActionTypes.BeneficioPageRight;
	constructor() {
	}
}

export class BeneficioCategoriasRequested implements Action {
	readonly type: string = BeneficioActionTypes.BeneficioCategoriasRequested;
	constructor() {
	}
}

export class BeneficioCategoriasLoaded implements Action {
	readonly type: string = BeneficioActionTypes.BeneficioCategoriasLoaded;
	constructor( public payload: { categorias: BeneficioCategoria[] } ) {
	}
}

export class BeneficioCategoriasCancelled implements Action {
	readonly type: string = BeneficioActionTypes.BeneficioCategoriasCancelled;
	constructor() {
	}
}

export class BeneficioCategoriasRight implements Action {
	readonly type: string = BeneficioActionTypes.BeneficioCategoriasRight;
	constructor() {
	}
}

export class BeneficioCategoriaChangeRequested implements Action {
	readonly type: string = BeneficioActionTypes.BeneficioCategoriaChangeRequested;
	constructor( public payload: { categoria: BeneficioCategoria } ) {
	}
}

export class BeneficioCategoriaChangeLoaded implements Action {
	readonly type: string = BeneficioActionTypes.BeneficioCategoriaChangeLoaded;
	constructor( public payload: { categoria: BeneficioCategoria } ) {
	}
}

export class BeneficioCategoriaChangeCancelled implements Action {
	readonly type: string = BeneficioActionTypes.BeneficioCategoriaChangeCancelled;
	constructor() {
	}
}


export type BeneficioActions = BeneficioPageRequested | BeneficioPageLoaded | BeneficioPageCancelled | BeneficioPageRight |
	BeneficioCategoriasRequested | BeneficioCategoriasLoaded | BeneficioCategoriasCancelled |
	BeneficioCategoriaChangeRequested | BeneficioCategoriaChangeLoaded | BeneficioCategoriaChangeCancelled;
